export enum AppwriteApiRoute {
    Email = 'email',
    Utility = 'utility',
    User = 'user',
    Translate = 'translate',
    OnShape = 'onshape',
    Migration = 'migration',
    Ups = 'ups',
    C3Reporting = 'c3-reporting',
    Database = 'database',
}
